import { render, staticRenderFns } from "./ClientsControl.vue?vue&type=template&id=37100674&scoped=true&"
import script from "./ClientsControl.vue?vue&type=script&lang=js&"
export * from "./ClientsControl.vue?vue&type=script&lang=js&"
import style0 from "./ClientsControl.vue?vue&type=style&index=0&id=37100674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37100674",
  null
  
)

export default component.exports